// extracted by mini-css-extract-plugin
module.exports = {"errorMessage":"PaymentError_errorMessage__CaHgv","error":"PaymentError_error__-y535"};